import type { JSX } from 'react';
import { CheckCircle, XCircle } from 'lucide-react';
import { TableCell } from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';

export function CandidateNameCell({
  name,
  email,
  onClick,
}: {
  name: string;
  email: string;
  onClick: () => void;
}): JSX.Element {
  return (
    <TableCell>
      <div>
        <button
          type="button"
          onClick={onClick}
          className="font-medium text-blue-600 dark:text-blue-400 hover:underline cursor-pointer text-left"
        >
          {name}
        </button>
        <p className="text-sm text-muted-foreground">{email}</p>
      </div>
    </TableCell>
  );
}

export function CountryCell({ country }: { country?: string | null }): JSX.Element {
  return (
    <TableCell>
      {country ? (
        <Badge variant="outline" className="text-xs">
          {country}
        </Badge>
      ) : (
        <span className="text-muted-foreground">-</span>
      )}
    </TableCell>
  );
}

export function ConsentCell({ consentGiven }: { consentGiven: boolean }): JSX.Element {
  return (
    <TableCell>
      {consentGiven ? (
        <div className="flex items-center gap-1 text-green-600">
          <CheckCircle className="h-4 w-4" />
          <span className="text-xs">Yes</span>
        </div>
      ) : (
        <div className="flex items-center gap-1 text-muted-foreground">
          <XCircle className="h-4 w-4" />
          <span className="text-xs">No</span>
        </div>
      )}
    </TableCell>
  );
}
